import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, Transition as _Transition } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "notifications"
};
const _hoisted_2 = { class: "notifications-list" };
const _hoisted_3 = ["src"];
const _hoisted_4 = { class: "notification-body" };
const _hoisted_5 = {
    key: 0,
    class: "older-notifications-toggle"
};
const _hoisted_6 = { class: "ad" };
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useAppState } from '@/composables/useAppState';
import { useAuth } from '@/composables/useAuth';
import { useCustomer } from '@/composables/useCustomer';
import { useApi } from '@/composables/useApi';
import CustomerLoadWait from './elements/CustomerLoadWait.vue';
import HeaderBlock from './elements/HeaderBlock.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'AchievementsPage',
    setup(__props) {
        const router = useRouter();
        const state = useAppState();
        useAuth();
        const { getCustomer } = useCustomer();
        const api = useApi();
        const achievements = ref(null);
        const expandedAchievements = ref({});
        const showOlderAchievements = ref(false);
        const daysToShow = ref(7);
        function getAchievements(onSuccess = null) {
            api.GET("/Customers/00000000-0000-0000-0000-000000000000/Achievements", (result) => {
                if (onSuccess)
                    onSuccess(result);
            }, false);
        }
        function csharpDateTimetoDateTime(dateString, humanificate = true) {
            const date = new Date(dateString);
            if (humanificate) {
                const now = new Date();
                const dateOnly = new Date(date.getFullYear(), date.getMonth(), date.getDate());
                const nowOnly = new Date(now.getFullYear(), now.getMonth(), now.getDate());
                const diffTime = nowOnly.getTime() - dateOnly.getTime();
                const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
                const options = { hour: '2-digit', minute: '2-digit' };
                if (diffDays === 0) {
                    return "Today at " + date.toLocaleTimeString([], options);
                }
                else if (diffDays === 1) {
                    return "Yesterday at " + date.toLocaleTimeString([], options);
                }
                else if (diffDays <= 7) {
                    return `${diffDays} days ago at ` + date.toLocaleTimeString([], options);
                }
            }
            return date.toLocaleString([], { hour: '2-digit', minute: '2-digit', year: 'numeric', month: 'numeric', day: 'numeric' });
        }
        function hasOlderAchievements() {
            if (!achievements.value)
                return false;
            const daysFrom = new Date();
            daysFrom.setDate(daysFrom.getDate() - daysToShow.value);
            return achievements.value.some(a => new Date(a.achievementDateTime) < daysFrom);
        }
        function getOlderAchievementsCount() {
            if (!achievements.value)
                return 0;
            const daysFrom = new Date();
            daysFrom.setDate(daysFrom.getDate() - daysToShow.value);
            return achievements.value.filter(a => new Date(a.achievementDateTime) < daysFrom).length;
        }
        function onLoad() {
            getCustomer(() => {
                getAchievements((result) => {
                    achievements.value = result;
                });
            });
        }
        onMounted(() => {
            onLoad();
        });
        return (_ctx, _cache) => {
            const _component_v_col = _resolveComponent("v-col");
            const _component_v_row = _resolveComponent("v-row");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                (_unref(state).customer)
                    ? (_openBlock(), _createBlock(HeaderBlock, {
                        key: 0,
                        title: "Achievements",
                        bgcolor: "white"
                    }))
                    : _createCommentVNode("", true),
                _createVNode(CustomerLoadWait, { customer: achievements.value }, null, 8, ["customer"]),
                _createVNode(_Transition, null, {
                    default: _withCtx(() => [
                        (achievements.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                _createElementVNode("div", _hoisted_2, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(achievements.value, (a) => {
                                        return (_openBlock(), _createBlock(_component_v_row, {
                                            key: a.id,
                                            class: "notificationRow"
                                        }, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_v_col, {
                                                    cols: "1",
                                                    class: "iconCol"
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createElementVNode("img", {
                                                            src: require('@/assets/points.png'),
                                                            class: "icon"
                                                        }, null, 8, _hoisted_3)
                                                    ]),
                                                    _: 1
                                                }),
                                                _createVNode(_component_v_col, null, {
                                                    default: _withCtx(() => [
                                                        _createElementVNode("div", _hoisted_4, [
                                                            _createElementVNode("p", null, _toDisplayString(a.achievement.description), 1)
                                                        ]),
                                                        _createElementVNode("small", null, _toDisplayString(a.achievement.points) + " point" + _toDisplayString(a.achievement.points > 1 ? 's' : '') + ". " + _toDisplayString(csharpDateTimetoDateTime(a.achievementDateTime)), 1)
                                                    ]),
                                                    _: 2
                                                }, 1024)
                                            ]),
                                            _: 2
                                        }, 1024));
                                    }), 128))
                                ]),
                                (hasOlderAchievements())
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                        _createElementVNode("a", {
                                            onClick: _cache[0] || (_cache[0] = ($event) => (showOlderAchievements.value = !showOlderAchievements.value)),
                                            class: "toggle-link"
                                        }, _toDisplayString(showOlderAchievements.value ? 'Hide older achievements' : `Show ${getOlderAchievementsCount()} older achievements`), 1)
                                    ]))
                                    : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_6, [
                                    _cache[2] || (_cache[2] = _createElementVNode("h1", null, "Stay in the loop", -1)),
                                    _cache[3] || (_cache[3] = _createElementVNode("p", null, "Make sure you have notifications enabled for the Money Guided app!", -1)),
                                    _createElementVNode("small", {
                                        onClick: _cache[1] || (_cache[1] = ($event) => (_unref(router).push('notifications')))
                                    }, "Notification Settings")
                                ])
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                })
            ], 64));
        };
    }
});
